import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import {
  getColorCodeForGivenCategory,
  getBoldLabelText,
  getNormalLabelText,
} from '../../../util/Insight360Utils';
import { BRAND_ICON_LIST } from '../../../constants';
import * as insight360Actions from '../../../actions/insight360Actions';

const getImageIcon = imageKey => {
  let selectedIcon;
  const imageComponent = _.find(BRAND_ICON_LIST, { id: imageKey });
  if (imageComponent !== undefined) {
    selectedIcon = imageComponent.selectedIcon;
  }
  return selectedIcon;
};

class BrandsSinglePersonaDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  renderDeepDiveSlider = value => {
    const { personaIndex, brandsDetail, selectedTab } = this.props;

    const deepDivePersonaObject = {
      personaIndex,
      category: brandsDetail.brandSubCategory,
      section: 'Brands',
      selectedTab,
    };
    this.props.insight360Actions.showDeepDivePopup(value, deepDivePersonaObject);
  }

  render() {
    const {
      brandsDetail, selectedIcon, categoryName, highestIndex } = this.props;


    let widthPercent = 0;
    const brandDetails = brandsDetail;
    const brandCategoryName = brandDetails.brandCategory;
    const iconCategoryName = brandDetails.iconCategory;
    const brandLabel = brandDetails.brandLabel;
    const brandLabelBold = getBoldLabelText(brandLabel);
    const brandLabelNormal = getNormalLabelText(brandLabel);
    const index = brandDetails.index;
    const reach = brandDetails.pct;
    widthPercent = `${_.round((index * 100) / highestIndex)}%`;
    return (
      <div>
        {brandsDetail !== undefined && (
          <div className="attitude-detail-grid">
            <div className="attitude-comparision-float">
              <div className="attitude-float">
              <div className="attitude-image-border attitude-float">
                  {getImageIcon(selectedIcon) === undefined && (
                    <div className="imageblock" />
                  )}
                  {getImageIcon(selectedIcon) !== undefined && (
                    <img
                      onClick={() => this.renderDeepDiveSlider(true)}
                      className="i360-demo-comparision-img pointer-cursor"
                      src={getImageIcon(selectedIcon)}
                      alt={categoryName}
                    />
                  )}
                  <div className="attitude-comparision-icon-labels pointer-cursor"
                    onClick={() => this.renderDeepDiveSlider(true)}
                  >
                    {brandCategoryName}
                  </div>
                </div>
              </div>

              <div className="attitude-comparision-metrics attitude-float pointer-cursor"
                onClick={() => this.renderDeepDiveSlider(true)}
              >
                <div>INDEX:&nbsp;&nbsp;{index}</div>
                <div>REACH:&nbsp;&nbsp;{reach} </div>
              </div>

              <div className="attitude-comparision-statement-float">
                <div className="large-12 medium-12 small-12 columns">
                  <div
                    className="attitude-status-bar pointer-cursor"
                    onClick={() => this.renderDeepDiveSlider(true)}
                    style={{
                      width: widthPercent,
                      backgroundColor: getColorCodeForGivenCategory(
                        iconCategoryName,
                        this.props.insight360studyInfo.ss
                      ),
                    }}
                  />
                  <div className="brands-comparision-data insight360-attitude-align pointer-cursor"
                    onClick={() => this.renderDeepDiveSlider(true)}
                    title={brandLabel}
                  >
                    <span style={{ fontWeight: 'bold' }}>{brandLabelBold}</span>
                    <span>{brandLabelNormal}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

BrandsSinglePersonaDetail.propTypes = {
  brandsDetail: PropTypes.shape({
    brandSubCategory: PropTypes.string,
  }),
  selectedIcon: PropTypes.string,
  categoryName: PropTypes.string,
  highestIndex: PropTypes.number,
  insight360studyInfo: PropTypes.shape({
    ss: PropTypes.string,
  }),
  selectedTab: PropTypes.string,
  personaIndex: PropTypes.number,
  insight360Actions: PropTypes.shape({
    showDeepDivePopup: PropTypes.func,
  }),
};


function mapDispatchToProps(dispatch) {
  return {
    insight360Actions: bindActionCreators(insight360Actions, dispatch),
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(BrandsSinglePersonaDetail);
